import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../libs/shared/ui/src/components/icon/icon';
import {center} from '../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export interface StartGuideItemProps {
  outerBackgroundColor: string;
  innerBackgroundColor: string;
  iconName: IconName;
}

/*
 * Style.
 */

interface StyledStartGuideOuterItemProps {
  $outerBackgroundColor: string;
}

interface StyledStartGuideInnerItemProps {
  $innerBackgroundColor: string;
}

const StyledSquareItemDiv = styled.div<StyledStartGuideOuterItemProps>`
  ${center()}
  height: 74px;
  width: 46px;
  background: ${(p) => p.$outerBackgroundColor};
  border-radius: 8px;
`;

const StyledCircleItemDiv = styled.div<StyledStartGuideInnerItemProps>`
  height: 30px;
  width: 30px;
  background: ${(p) => p.$innerBackgroundColor};
  border-radius: 50%;
  ${center()}
`;

/*
 * Component.
 */

export const StartGuideItem: FC<StartGuideItemProps> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledSquareItemDiv $outerBackgroundColor={props.outerBackgroundColor}>
      <StyledCircleItemDiv $innerBackgroundColor={props.innerBackgroundColor}>
        <Icon name={props.iconName} color={theme.greys.white} />
      </StyledCircleItemDiv>
    </StyledSquareItemDiv>
  );
};
